import React from 'react';
import styled from 'styled-components/macro';
import { colors, distances } from '../../styles/constants';

import docs from './icons/docs-active.svg';
import help from './icons/help-active.svg';

const iconMap = {
    docs,
    help,
};

interface AppBarIconProps extends React.DOMAttributes<HTMLSpanElement> {
    icon: keyof typeof iconMap;
    href: string;
    title: string;
    className?: string;
}

const AppBarIconExternalLink = (
    {
        icon,
        href,
        title,
    }: AppBarIconProps
) => {
    return (
        <AppBarIconElem
            href={href}
            icon={iconMap[icon]}
            target="_blank"
        >
            <StyledP>{title}</StyledP>
        </AppBarIconElem>
    );
};

interface AppBarIconElemProps {
    icon: string;
}

const StyledP = styled.p`
    margin: 0;
    color: ${colors.background};
    font-size: 14px;
`;

const AppBarIconElem = styled.a<AppBarIconElemProps>`
    position: relative;
    background: transparent;
    height: 64px;
    width: 200px;
    display: block;
    text-decoration: none;
    user-select: none;
    margin: 0;
    padding: 16px 0px 16px 45%;
    line-height: 225%;
    background-image: url(${(props) => props.icon});
    background-repeat: no-repeat;
    background-position: 30%;
    &:hover {
        background-color: rgba(255, 255, 255, 0.2);
    }
    &.active:hover,
    &.active {
        &:before {
            position: absolute;
            content: ' ';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: ${colors.background};
            top: 27px;
            left: 20px;
            @media (max-width: 768px) {
                left: ${distances.tiny};
                top: 14px;
            }
        }
    }
    @media (max-width: 768px) {
        width: 100%;
        height: 39px;
        padding: 4px 0px 4px 20%;
        background-position: 10%;
    }
`;

export default AppBarIconExternalLink;
